module.exports = __webpack_public_path__ + "static/media/login1.ed61e7b7.png";